module.exports = __webpack_public_path__ + "img/milkin.60b0d288.png";